import AreaHeader from "./AreaHeader"

export default AreaHeader
